import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'catalog-perimeter-select-base',
  templateUrl: './catalog-perimeter-select-base.component.html',
  styleUrls: ['./catalog-perimeter-select-base.component.scss'],
})
export class CatalogPerimeterSelectBaseComponent {
  @Output() select = new EventEmitter<void>();
  searchWidthFull = true;
}
